import { useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { UrlApi } from "../../../services/apirest";
import { calcularVencimientoPorPeriodo } from "../utils/calcvencimiento";

const WINDOWS = [
  { dias: 7, label: "URGENTE – Vencen en 7 días", prefix: "🔴" },
  { dias: 15, label: "PRÓXIMAS – Vencen en 15 días", prefix: "🟡" },
  { dias: 30, label: "A TENER EN CUENTA – Vencen en 30 días", prefix: "🔵" },
];

export function useVencimientoAlertas(plantaSeleccionada) {
  const currentUser = localStorage.getItem("user") ?? "";

  useEffect(() => {
    if (!plantaSeleccionada || !currentUser) return;

    const today = moment().format("YYYY-MM-DD");
    const storageKey = `venc_alerta_${plantaSeleccionada}_${today}`;
    if (localStorage.getItem(storageKey)) return;

    const check = async () => {
      try {
        const { data: vencData } = await axios.get(
          `${UrlApi}/mp_vencimientos/${plantaSeleccionada}`
        );

        const hoy = moment().startOf("day");
        const buckets = WINDOWS.map(() => []);

        (vencData ?? []).forEach((equipo) => {
          (equipo.tareas ?? []).forEach((tarea) => {
            const baseFecha = tarea.fecha_realizado || tarea.ultimo;
            const venc = calcularVencimientoPorPeriodo(baseFecha, tarea);
            if (venc.isBefore(hoy)) return;

            const diffDias = venc.diff(hoy, "days");
            const item = `• ${equipo.nombre_equipo ?? equipo.equipo} – ${tarea.tarea} – ${venc.format("DD/MM/YYYY")}`;

            for (let i = WINDOWS.length - 1; i >= 0; i--) {
              if (diffDias <= WINDOWS[i].dias) {
                buckets[i].push(item);
                break;
              }
            }
          });
        });

        const hasAlerts = buckets.some((b) => b.length > 0);
        localStorage.setItem(storageKey, "true");

        if (!hasAlerts) return;

        let body = "";
        WINDOWS.forEach(({ label, prefix }, i) => {
          if (buckets[i].length > 0) {
            if (body) body += "\n";
            body += `${prefix} ${label}:\n${buckets[i].join("\n")}`;
          }
        });

        await axios.post(`${UrlApi}/mensajes/`, {
          emisor: "sistema",
          receptor: currentUser,
          referencia: `Vencimientos próximos – ${moment().format("DD/MM/YYYY")}`,
          mensaje: body,
        });
      } catch {
        // Silently ignore — non-critical background check
      }
    };

    check();
  }, [plantaSeleccionada, currentUser]);
}
